import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=1010f728&scoped=true"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010f728",
  null
  
)

export default component.exports